<template>
  <div class="login-page">
    <div class="login-container">
      <div class="login-box">
        <div class="login-header">
          <img
            alt="Gaming Corps"
            class="login-logo"
            src="@/assets/logo.png"
          >
          <h1>Translation Manager</h1>
          <p>{{ message }}</p>
        </div>
        <div class="login-actions">
          <a
            v-if="loginUrl"
            class="login-gateway-link"
            :href="loginUrl"
          >Open sign in</a>
          <div v-else class="spinner" />
        </div>
        <p class="login-footer">Internal tool · authorized users only</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginScreen',

  props: {
    message: {
      type: String,
      default: 'Sign in required'
    },
    loginUrl: {
      type: String,
      default: ''
    }
  }
};
</script>
